/**
 * Mock Implementation of ICurrentUserService
 * Uses mock data to simulate API responses
 *
 * SWAP INSTRUCTIONS (when BE ready):
 * 1. Create current-user.service.api.ts implementing ICurrentUserService
 * 2. Update index.ts to export API implementation instead of mock
 */

import { getMeMock } from "@/infrastructure/data/mocks/current-user";
import { ICurrentUserService } from "@/infrastructure/services/current-user/current-user.service";

/**
 * Mock service implementation
 * Delegates to mock data layer
 */
export const mockCurrentUserService: ICurrentUserService = {
  getMe: getMeMock,
};
